module.exports = __webpack_public_path__ + "static/media/C9.5fa0be39.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C9.png
// module id = 901
// module chunks = 0